// Generated by ReScript, PLEASE EDIT WITH CARE


var sdkDomainUrl = sdkUrl + publicPath;

var apiEndPoint = {
  contents: undefined
};

function setApiEndPoint(str) {
  apiEndPoint.contents = str;
}

function getApiEndPoint(publishableKeyOpt, isConfirmCallOpt) {
  var publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  var isConfirmCall = isConfirmCallOpt !== undefined ? isConfirmCallOpt : false;
  var testMode = publishableKey.startsWith("pk_snd_");
  var str = apiEndPoint.contents;
  if (str !== undefined) {
    return str;
  }
  var backendEndPoint$1 = isConfirmCall ? confirmEndPoint : backendEndPoint;
  if (isProductionEnv && testMode) {
    return "https://beta.hyperswitch.io/api";
  } else {
    return backendEndPoint$1;
  }
}

function addCustomPodHeader(arr, customPodUri) {
  if (customPodUri !== undefined && customPodUri !== "") {
    arr.push([
          "x-feature",
          customPodUri
        ]);
  }
  return Object.fromEntries(arr);
}

var switchToInteg = false;

var isLocal = false;

export {
  switchToInteg ,
  isLocal ,
  sdkDomainUrl ,
  apiEndPoint ,
  setApiEndPoint ,
  getApiEndPoint ,
  addCustomPodHeader ,
}
/* sdkDomainUrl Not a pure module */
